import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'
import '@fontsource/material-symbols-outlined'
import { initNativeShell } from '@/lib/native-shell'
import { setupDemoMode, isDemoMode } from '@/api/demo/setup'
import { startThemeRuntime } from '@/theme'

// Activate demo mode when VITE_DEMO_MODE=true (no backend required)
if (isDemoMode()) {
  setupDemoMode()
}

// Boot the theme runtime BEFORE React renders so the first paint
// already has the correct CSS variables, dark class, and font scale.
startThemeRuntime()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)

// Do not block the first paint on native plugin setup.
void initNativeShell()
